import { useFooterViewModel } from '../../ViewModel/FooterViewModel.js';
import '../styles/Footer.css';

function Footer() {
    const { currentYear } = useFooterViewModel();

    const handleBrandClick = (event) => {
        event.preventDefault();
        if (typeof window === 'undefined') {
            return;
        }

        const isHome = window.location.pathname === '/' || window.location.pathname === '/index.html';
        if (!isHome) {
            window.history.pushState({}, '', '/');
            window.dispatchEvent(new PopStateEvent('popstate'));
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <footer className="footer">
            <div className="footer-inner">
                <a href="/" className="footer-brand" aria-label="Gå till startsidan" onClick={handleBrandClick}>
                    <div className="footer-brand-text">
                        <strong>Shekonomi</strong>
                        <span>Redovisning & rådgivning</span>
                    </div>
                </a>

                <p className="footer-copyright">Copyright @{currentYear} Shekonomi</p>

                <div className="footer-developer">
                    <p>
                        Denna sida är fullt utvecklad av{' '}
                        <span className="footer-dev-brand">
                            <span className="footer-dev-gt">&gt;</span>
                            <span className="footer-dev-it">IT</span>
                            <span className="footer-dev-hjalp">
                                -hjälparn<span className="footer-dev-blink-a">a</span>
                            </span>
                        </span>
                        .
                    </p>
                    <a href="https://www.ithjalparna.se" target="_blank" rel="noopener noreferrer" className="footer-link">
                        www.ithjalparna.se
                    </a>
                </div>

                <div className="footer-policy">
                    <a href="/gdpr" className="footer-policy-link">Läs hur vi hanterar GDPR</a>
                </div>
            </div>
        </footer>
    );
}

export default Footer;